// extracted by mini-css-extract-plugin
module.exports = {"PostContainer":"PostContainer_PostContainer__3ZJer"};